import { ThemeUIStyleObject } from 'theme-ui';
import { CarrotTheme } from '..';

export type TextVariantProp = keyof typeof text;

const text: Record<string, ThemeUIStyleObject> = {
    default: {
        fontFamily: (theme: CarrotTheme) => theme.fonts.body,
        lineHeight: (theme: CarrotTheme) => theme.lineHeights.body,
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.body,
        color: (theme: CarrotTheme) => theme.colors.black80,
    },
    error: {
        variant: 'text.default',
        color: (theme: CarrotTheme) => theme.colors.errorRed,
    },
    accent: {
        variant: 'text.default',
        color: (theme: CarrotTheme) => theme.colors.black60,
    },
    disabled: {
        variant: 'text.default',
        color: (theme: CarrotTheme) => theme.colors.black40,
    },
    subtext: {
        variant: 'text.default',
        color: (theme: CarrotTheme) => theme.colors.black40,
    },
    dark: {
        variant: 'text.default',
        color: (theme: CarrotTheme) => theme.colors.black,
    },
    light: {
        variant: 'text.default',
        color: (theme: CarrotTheme) => theme.colors.white,
    },
    heading: {
        fontFamily: (theme: CarrotTheme) => theme.fonts.heading,
        lineHeight: (theme: CarrotTheme) => theme.lineHeights.heading,
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.heading,
    },
    caps: {
        variant: 'text.default',
        textTransform: 'uppercase',
        letterSpacing: '0.07em',
    },
};
export default text;
